import { doc, getDoc, getDocs, query, collection, where, and, setDoc, orderBy } from "firebase/firestore"
import { db } from '../firebase'
import { useLocation } from "react-router-dom"
import { useState, useEffect, useContext } from "react"
import { AuthContext } from "../context/AuthContext"
import Button from 'react-bootstrap/Button';
import EditProfileModal from "../components/EditProfileModal"
import ChangePasswordModal from "../components/ChangePasswordModal"
import ListListings from "../components/mainpage/ListListings"
import { ListingContextProvider } from "../context/ListingsContext"

const Profile = () => {
    const location = useLocation()
    console.log(location.pathname.split('/').at(-1))
    const userId = location.pathname.split('/').at(-1)
    // const {listing_id} = location.state
    // const listingId = localStorage.getItem("listingId")
    // console.log(listingId)
    // console.log(localStorage)
    // localStorage.removeItem("listingId")
    // console.log(localStorage)
    const { currentUser } = useContext(AuthContext)
    const [user, setUser] = useState()
    const [editProfileOpen, setEditProfileOpen] = useState()
    const [changePasswordOpen, setChangePasswordOpen] = useState()
    const [listings, setListings] = useState(null)
    console.log(currentUser)
    const getUser = async () => {
        console.log("****", userId)
        try {
            if (currentUser.uid === userId) {
                setUser(currentUser)
            } else {
                await getDoc(doc(db, "users", userId))
                .then((res) => {
                    setUser(res.data())
                    console.log(res.data())
                    console.log(user)
                })
            }

            const q = query(
                collection(db, "listings"),
                and(where("user.userId", "==", userId), where("active", "==", true)),
                orderBy("createdAt", "desc")
            )
            await getDocs(q)
            .then((res) => {
                if (res.docs.length > 0) {
                    const listingsArray = res.docs.map(listing => listing.data())
                    console.log(listingsArray)
                    setListings(listingsArray)
                }
            })
        } catch(err) {
            return err
        }
    }

    useEffect(() => {
        getUser()
    }, [])

    const copyData = async () => {
        return await setDoc(
            doc(db,`users/${userId}/private`, "data"),
            {
                activeBids: user.activeBids,
                activeChats: user.activeChats.buying.concat(user.activeChats.selling),
                activeListings: user.activeListings,
                addressData: user.addressData,
                birthday: user.birthday,
                email: user.email,
            }
        )
    }

    return (
        <div className="page-container profile-page-container">
            {/* <div className="page-header">
                    <span className="header-text">User Profile</span>
            </div> */}
            <div className="profile-page-content">
                {user ?
                <div className="profile-display-container">
                    {user.avatarUrl ?
                    <img src={user.avatarUrl} className="profile-avatar"/>:
                    <i className="material-icons profile-avatar">account_circle</i>}

                    <div className="profile-name">{user.firstName} {user.lastName}</div>
                    {/* <div className="profile-data">
                        <div className="profile-item">
                            <div>Name:</div>
                            <div>{user.firstName} {user.lastName}</div>
                        </div>
                    </div> */}
                    <EditProfileModal editProfileOpen={editProfileOpen} setEditProfileOpen={setEditProfileOpen} user={user}/>
                    <ChangePasswordModal changePasswordOpen={changePasswordOpen} setChangePasswordOpen={setChangePasswordOpen}/>
                </div>
                :<div>"Loading Profile"</div>
                }
                {(user && (user.uid === currentUser.uid)) && 
                    <div className="profile-buttons">
                        <Button
                            type="button"
                            className="btn btn-primary edit-profile-btn"
                            onClick={() => setEditProfileOpen(true)}
                        >
                            Edit Profile
                        </Button>
                        <Button
                            type="button"
                            className="btn btn-primary edit-profile-btn"
                            onClick={() => setChangePasswordOpen(true)}
                        >
                            Change Password
                        </Button>
                    </div>
                }
                <div className="profile-listings-container">
                    {/* {
                        listings.length > 0 ? 
                        listings.map((listing, i) => (
                            <ListingCard key={`listing-card-${i}`} listing={listing}></ListingCard>
                        )) : 
                        <div>No listings found</div>
                    } */}
                    {/* {
                        listings && listings.length > 0 ? 
                        <ListingContextProvider>
                            <ListListings listings={listings} className={"profile-listings"}/> 
                        </ListingContextProvider> :
                        null
                    } */}
                    <ListingContextProvider>
                        <ListListings listings={listings} className={"profile-listings"}/> 
                    </ListingContextProvider>
                </div>

                {/* <Button
                    type="button"
                    className="btn btn-primary edit-profile-btn"
                    onClick={() => copyData(user)}
                >
                    Copy Data
                </Button> */}

            </div>
        </div>
    )
}

export default Profile